import RailsResource from "./rails-resource";

export default new class extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'tuitions',
      ajaxLoader: true
    });
  }

  htmlDetails(tuitionId) {
    return this.call(`${this.url}/${this.resource}/${tuitionId}/details`, false);
  }

  paymentMethodHtmlDetails(tuitionId, chargeId) {
    return this.call(`${this.url}/${this.resource}/${tuitionId}/charges/${chargeId}`, false);
  }

  fowardInvoiceAlert(tuitionId, chargeId, bankbillEmail) {
    return this.post(`${this.url}/${this.resource}/${tuitionId}/charges/${chargeId}/forward-invoice-alert`, true, {
      email: bankbillEmail
    });
  }

  fowardReceipt(tuitionId, chargeId, bankbillEmail) {
    return this.post(`${this.url}/${this.resource}/${tuitionId}/charges/${chargeId}/forward-receipt`, true, { email: bankbillEmail });
  }

  updateChargeDueAt(tuitionId, chargeId, dueAt, bankbillEmail) {
    return this.post(`${this.url}/${this.resource}/${tuitionId}/charges/${chargeId}/update-charge`, true, {
      email: bankbillEmail,
      due_at: dueAt
    });
  }

  undoPayment(tuitionId) {
    return this.patch(`${this.url}/${this.resource}/${tuitionId}/undo-payment.json`, true);
  }
}